// i18n area 'hci' — locale pt-PT (pt-PT, task #171, onda 1): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/hci.pt-PT.meta.json.
import type { enUS } from './hci'

export const ptPT: typeof enUS = {
  hci: {
    ceph: {
      title: 'Clusters Ceph',
      createButton: 'Criar cluster Ceph',
      emptyTitle: 'Nenhum cluster Ceph gerido',
      emptyBody: 'O TVirt distribui e detém o Ceph nos nós membros, hiperconvergente com a carga de VMs. Crie um cluster: o primeiro monitor e o seu manager nascem automaticamente no nó de controlo escolhido — depois faça-o crescer com mais monitores e dispositivos OSD.',
      pageTitle: 'Clusters Ceph',
      colState: 'Estado',
      colMembers: 'Membros',
      colSize: 'Tamanho',
      colVersion: 'Versão Ceph',
      sizeCell: '{used} GiB usados de {total} GiB totais',
      phase: {
        'not-deployed': 'Não deployado',
        deploying: 'Deploy em curso',
        healthy: 'Saudável',
        degraded: 'Degradado',
        error: 'Erro',
        destroying: 'A destruir',
        destroyed: 'Destruído'
      },
      health: {
        HEALTH_OK: 'Saudável (HEALTH_OK)',
        HEALTH_WARN: 'Com avisos (HEALTH_WARN)',
        HEALTH_ERR: 'Em erro (HEALTH_ERR)',
        unknown: 'Ainda não observada',
        observedAt: 'observada {time}'
      },
      create: {
        title: 'Criar cluster Ceph',
        info: 'Ao criar um novo cluster Ceph escolhe-se o primeiro nó no qual serão instaladas as funções MON e MGR. Há também que indicar que subnet usar para fazer correr o tráfego Ceph: a subnet public é usada para o tráfego de rede geral, enquanto a subnet cluster é usada para as réplicas internas entre os OSDs; não são obrigatórias subnets diferentes.',
        controlNode: 'Nó de controlo',
        controlNodeHint: 'O nó membro onde nascem o primeiro MON + MGR.',
        publicSubnet: 'Subnet public',
        publicSubnetHint: 'Uma Subnet registada no IPAM — a public_network do Ceph. Imutável depois da criação.',
        clusterSubnet: 'Subnet cluster',
        clusterSubnetHint: 'Uma Subnet registada no IPAM — a cluster_network do Ceph (réplica/backfill).',
        noSubnets: 'Nenhuma Subnet registada — crie-as primeiro no IPAM',
        sameSubnet: 'A mesma subnet para o tráfego public e cluster',
        sameSubnetHint: 'Marcada = a rede cluster (réplica/backfill) coincide com a public. Desmarcada = escolha a sua subnet E o endereço do nó de controlo dentro dela.',
        controlAddress: 'Endereço do nó de controlo',
        controlAddressHint: 'Um endereço que o IPAM conhece para o nó dentro da subnet public.',
        controlClusterAddress: 'Endereço cluster do nó de controlo',
        controlClusterAddressHint: 'Um endereço que o IPAM conhece para o nó dentro da subnet cluster.',
        noAddresses: 'O IPAM não conhece endereços deste nó dentro da subnet escolhida',
        started: 'Cluster criado — o bootstrap prossegue como macrotask; a fase atualiza-se sozinha',
        error: 'O cluster foi recusado'
      },
      detail: {
        actions: 'Ações disponíveis',
        tabOverview: 'Visão geral',
        tabManagementNodes: 'MON & MGR',
        tabDisks: 'OSD',
        tabPools: 'Pools',
        tabObjects: 'Objetos',
        tabCrush: 'CRUSH Map',
        tabCephfs: 'CephFS',
        tabAdvanced: 'Avançadas',
        phase: 'Fase',
        checksTitle: 'Checks de saúde ativos',
        noChecks: 'Nenhum check de saúde ativo',
        checkMuted: 'silenciado',
        summaryPools: 'Pools',
        summaryFilesystems: 'Filesystems',
        nodesCard: 'Nós',
        monHint: 'Um MGR corre colocalizado com cada MON. Três MONs são o quórum recomendado; um cluster de laboratório arranca com um. OSDs e MDS vivem nos seus próprios tabs.',
        monHintSplit: 'MON e MGR estão disjuntos neste cluster (Avançadas): cada função é uma membership própria por nó. Três MONs são o quórum recomendado; pelo menos um MGR tem de existir.',
        noMons: 'Nenhum monitor declarado',
        addNode: 'Adicionar nó',
        removeNode: 'Remover nó',
        removeNodeFrom: 'Remover o nó {node} (o seu MON e o MGR colocalizado)',
        roleMon: 'Função MON',
        roleMgr: 'Função MGR',
        roleNa: 'N/A',
        roleNotObserved: 'ainda não observado',
        monInQuorum: 'em quórum',
        monOutQuorum: 'fora do quórum',
        mgrActive: 'ativo',
        mgrStandby: 'standby',
        addRoleMon: 'Adicionar função MON',
        removeRoleMon: 'Remover função MON',
        addRoleMgr: 'Adicionar função MGR',
        removeRoleMgr: 'Remover função MGR',
        restartMon: 'Reiniciar serviço MON',
        restartMgr: 'Reiniciar serviço MGR',
        addMon: 'Adicionar MON',
        removeMon: 'Remover MON',
        removeMonFrom: 'Remover a função MON de {node}',
        addMgr: 'Adicionar MGR',
        removeMgr: 'Remover MGR',
        removeMgrFrom: 'Remover a função MGR de {node}',
        addMds: 'Adicionar MDS',
        removeMds: 'Remover MDS',
        removeMdsFrom: 'Remover a função MDS de {node}',
        mdsSection: 'Metadata servers (MDS)',
        noMds: 'Nenhum MDS declarado — um filesystem exige primeiro um',
        mdsHint: 'A membership MDS é própria desde o primeiro dia: um cluster sem CephFS não declara nenhum, um ativo mais um standby servem bem um filesystem. O Ceph elege ativos e standbys entre os daemons declarados.',
        mdsActiveFor: 'ativo — {fs}',
        mdsNotObserved: 'ainda não observado',
        lastMdsGuard: 'O último MDS não se pode remover enquanto existir um filesystem — remova primeiro os filesystems',
        lastMonGuard: 'O último MON não se pode remover — destruir o cluster é a única saída',
        lastMgrGuard: 'O último MGR não se pode remover — um cluster gerido nunca corre sem manager',
        registerDevice: 'Adicionar OSD',
        unregisterDevice: 'Anular registo',
        activeDeviceGuard: 'OSD ativo — sai pelo ciclo de vida OSD, não pelo registo',
        colNode: 'Nó',
        devicePhase: { registered: 'Registado', active: 'Ativo' },
        health: 'Saúde',
        state: 'Estado',
        fsid: 'fsid',
        fsidPending: 'ausente — repita o bootstrap',
        version: 'Versão Ceph',
        publicNetwork: 'Rede public',
        clusterNetwork: 'Rede cluster',
        clusterNetworkCollapsed: '= public',
        noActions: 'Nenhuma ação disponível nesta fase',
        destroyedNote: 'Cluster destruído — a linha é removida automaticamente em breve'
      },
      overview: {
        services: 'Serviços',
        ok: 'saudável',
        warning: 'warning',
        down: 'em baixo',
        pgTitle: 'Estados dos PGs',
        pgTotal: '{n} PGs no total',
        capacityTitle: 'Espaço',
        ioTitle: 'I/O atual',
        ioReadBw: 'Largura de banda de leitura',
        ioWriteBw: 'Largura de banda de escrita',
        ioReadIops: 'IOPS de leitura',
        ioWriteIops: 'IOPS de escrita',
        notObserved: 'ainda não observado'
      },
      osd: {
        colId: 'ID',
        colClass: 'Device class',
        colState: 'Estado',
        colSize: 'Tamanho',
        colPgs: 'PGs',
        empty: 'Nenhum OSD — adicione um a partir de um disco de dados declarado',
        markIn: 'Marcar IN',
        markOut: 'Marcar OUT',
        scrub: 'Executar scrub',
        deepScrub: 'Executar scrub profundo',
        restart: 'Reiniciar serviço',
        details: 'Detalhes',
        actionGuard: 'Só num OSD ativo de um cluster deployado',
        inTitle: 'Marcar OSD IN',
        inBody: 'osd.{id} volta à distribuição dos dados (ceph osd in): o Ceph reequilibra dados de volta para ele.',
        outTitle: 'Marcar OSD OUT',
        outBody: 'osd.{id} sai da distribuição dos dados (ceph osd out): os seus dados reequilibram-se para outro lado e a redundância fica REDUZIDA enquanto o backfill corre. Reversível a qualquer momento com Marcar IN.',
        scrubTitle: 'Agendar scrub',
        scrubBody: 'É agendado um scrub de osd.{id}: o mon coloca-o na fila e os estados dos PGs dos sweeps seguintes contam o desfecho.',
        deepScrubTitle: 'Agendar scrub profundo',
        deepScrubBody: 'É agendado um scrub profundo de osd.{id}: a variante que verifica os bytes — mais pesada no I/O, a mesma mecânica.',
        restartTitle: 'Reiniciar serviço OSD',
        restartBody: 'osd.{id} é parado e reiniciado através da supervisão do worker no seu nó.',
        started: 'Ação iniciada — a observação atualiza-se sozinha',
        error: 'A ação OSD foi recusada'
      },
      osdDetail: {
        title: 'Detalhes do OSD',
        tabGeneral: 'Geral',
        tabNetwork: 'Rede',
        tabDevices: 'Dispositivos',
        version: 'Versão',
        hostname: 'Hostname',
        dataPath: 'Caminho de dados do OSD',
        objectStore: 'Object store do OSD',
        encrypted: 'Encriptado',
        yes: 'Sim',
        no: 'Não',
        memory: 'Utilização de memória (PSS)',
        pid: 'Process ID (PID)',
        front: 'Endereço front (client & monitor)',
        hbFront: 'Endereço heartbeat front',
        back: 'Endereço back (OSD)',
        hbBack: 'Endereço heartbeat back',
        colDevice: 'Device',
        colType: 'Tipo',
        colPhysical: 'Device físico',
        colSize: 'Tamanho',
        volumeTitle: 'Detalhes do volume',
        creationTime: 'Data de criação',
        lvName: 'LV Name',
        lvPath: 'LV Path',
        lvUuid: 'LV UUID',
        vgName: 'VG Name',
        noDevices: 'Nenhum device observado para este OSD'
      },
      restart: {
        title: 'Reiniciar serviço',
        monBody: 'O daemon MON em {node} é parado e reiniciado através da supervisão do worker.',
        mgrBody: 'O daemon MGR em {node} é parado e reiniciado através da supervisão do worker.',
        started: 'Reinício iniciado — a observação atualiza-se sozinha',
        error: 'O reinício foi recusado'
      },
      encryptionMode: {
        alwaysOn: 'Sempre ativada (dmcrypt)',
        alwaysOff: 'Sempre desativada',
        perOsd: 'Escolhida por cada OSD',
        section: 'Encriptação OSD at rest',
        title: 'Alterar modo de encriptação OSD',
        hint: 'Como são preparados os NOVOS OSDs. Os OSDs existentes mantêm o seu estado por disco: para o alterar, remove-se e recria-se o OSD.',
        body: 'O modo passa a "{mode}" e vale SÓ para os NOVOS OSDs: cada OSD existente mantém o seu estado de encriptação atual.',
        apply: 'Alterar modo',
        error: 'A alteração de modo foi recusada'
      },
      pin: {
        address: 'Endereço public (pin opcional)',
        clusterAddress: 'Endereço cluster (pin opcional)',
        autoPlaceholder: 'automático na subnet {cidr}',
        hint: 'Endereçamento por daemon: vazio = o Ceph agarra-se sozinho dentro da rede declarada; preenchido = esta instância fica pinada ao endereço na sua secção de conf.'
      },
      addMon: {
        title: 'Adicionar nó',
        node: 'Nó',
        address: 'Endereço public',
        addressHint: 'Os endereços do nó que o IPAM conhece dentro da subnet public — automático quando uma declaração existente cobre o nó.',
        clusterAddress: 'Endereço cluster',
        clusterAddressHint: 'Obrigatório: a subnet cluster é separada e o nó ainda não está declarado nela.',
        noAddresses: 'O IPAM não conhece endereços deste nó dentro da subnet',
        error: 'A adição do mon foi recusada'
      },
      removeMon: {
        title: 'Remover MON',
        body: 'O MON e o seu MGR colocalizado deixam o nó {node}. Num cluster deployado os daemons são parados e removidos do quórum.',
        error: 'A remoção do MON foi recusada'
      },
      addMgr: {
        title: 'Adicionar MGR',
        node: 'Nó',
        hint: 'Avançadas (MON/MGR disjuntos): um manager standalone nasce no nó membro escolhido com uma task com afinidade ao nó. A eleição active/standby do Ceph escolhe sozinha o MGR ativo.',
        error: 'A adição do MGR foi recusada'
      },
      removeMgr: {
        title: 'Remover MGR',
        body: 'O MGR standalone deixa o nó {node}. Num cluster deployado o daemon é parado e o seu estado removido; o MON do nó (se existir) não é tocado.',
        error: 'A remoção do MGR foi recusada'
      },
      addMds: {
        title: 'Adicionar MDS',
        node: 'Nó',
        hint: 'O metadata server do CephFS: nasce no nó membro escolhido com uma task com afinidade ao nó, supervisionada pelo worker como o MON e o MGR. O Ceph elege sozinho ativos e standbys — um ativo mais um standby servem bem um filesystem.',
        error: 'A adição do MDS foi recusada'
      },
      removeMds: {
        title: 'Remover MDS',
        body: 'O MDS deixa o nó {node}. Num cluster deployado o daemon é parado e o seu estado removido; a API recusa o último MDS enquanto um filesystem precisar dele.',
        error: 'A remoção do MDS foi recusada'
      },
      split: {
        title: 'MON/MGR disjuntos',
        label: 'Permitir MON e MGR em nós disjuntos',
        hint: 'Desligado (default) = o standard ratificado: um MGR corre colocalizado com cada MON, uma única membership. Ligado = a membership dos MGRs torna-se própria, gerida com as ações Adicionar/Remover MGR no tab Nós de gestão.',
        enable: 'Ativar',
        disable: 'Desativar',
        enableBody: 'A membership dos MGRs torna-se independente dos MONs, inicializada a partir da colocalização atual. As ações Adicionar/Remover MGR armam-se no tab Nós de gestão. Isto relaxa o default da plataforma — mantenha-o só se souber porque precisa dele.',
        disableBody: 'Regresso à colocalização standard: um MGR com cada MON, uma única membership. Legal só se a membership dos MGRs já coincidir com os MONs — alinhe-a primeiro com Adicionar/Remover MGR, ou a API recusará.',
        error: 'A alteração foi recusada'
      },
      rawEditor: {
        title: 'Editor CRUSH em bruto',
        label: 'Mostrar o editor em bruto da crushmap no tab CRUSH',
        hint: 'Desligado (default) = a superfície guiada das regras é a ferramenta standard. Ligado = o tab CRUSH mostra também a crushmap decompilada como texto editável. Guardar exige sempre sudo, o nome do cluster como confirmação, e passa por compile + test do crushtool ANTES de chegar ao cluster.'
      },
      osdFlags: {
        section: 'Flags OSD globais',
        title: 'Override de flags OSD',
        notObserved: 'ainda não observadas',
        standardFlowsHint: 'Os fluxos standard da plataforma gerem estas flags sozinhos nos casos normais (a manutenção de um nó define um noout circunscrito, a substituição de um disco passa pelo ciclo de vida OSD). Esta secção é o override manual para o operador que sabe o que está a fazer.',
        notDeployedGuard: 'As flags OSD existem só num cluster deployado',
        set: 'Definir flag',
        unset: 'Remover flag',
        setBody: 'A flag global {flag} será DEFINIDA no osdmap. Fica até ser removida explicitamente — uma flag esquecida degrada a autorreparação do cluster.',
        unsetBody: 'A flag global {flag} será REMOVIDA do osdmap.',
        error: 'A alteração da flag foi recusada',
        flag: {
          noout: 'Nenhum OSD é marcado out da distribuição dos dados — sem reequilíbrio na perda de um daemon',
          norebalance: 'O reequilíbrio dos dados está suspenso',
          nobackfill: 'O backfill está suspenso',
          norecover: 'O recovery está suspenso',
          pause: 'TODO o I/O dos clients está em pausa (leituras e escritas)',
          noin: 'Os OSDs que arrancam não são marcados in automaticamente',
          nodown: 'Os OSDs inalcançáveis não são marcados down — mascara falhas reais'
        }
      },
      pools: {
        section: 'Pools',
        create: 'Criar pool',
        createGuard: 'As pools existem só num cluster deployado',
        notObserved: 'Nenhuma observação das pools — o sweep do mon reporta aqui',
        empty: 'Nenhuma pool no cluster',
        colName: 'Nome',
        colReplication: 'Size / min size',
        colPgNum: 'PGs',
        colApplication: 'Aplicação',
        colRule: 'Regra CRUSH',
        colUsage: 'Utilização',
        observedAtLabel: 'Observado a',
        objects: '{n} objetos',
        inUseBy: 'em uso por {name}',
        internalGuard: 'Pool interna do Ceph — a plataforma nunca a elimina',
        delete: 'Eliminar pool',
        deleteGuard: 'Consumida pelo storage {name} — elimine primeiro o storage',
        hint: 'Só pools replicadas (erasure coding fora do scope v1). A replicação vive no Ceph: esta tabela é a verdade observada pelo sweep do mon.',
        createTitle: 'Criar pool',
        createHint: 'A pool nasce no cluster com a replicação pedida e a aplicação rbd ativada — o trabalho é feito por uma task num nó MON. Ligue "Propor como storage" para a consumir logo no mesmo gesto.',
        name: 'Nome da pool',
        nameHint: 'DNS-safe (minúsculas, dígitos, hífenes).',
        size: 'Réplicas (size)',
        sizeHint: 'Cópias de cada objeto. Default 3.',
        minSize: 'Réplicas mínimas (min_size)',
        minSizeHint: 'Cópias mínimas para servir I/O — segue size − 1 até que o altere.',
        createError: 'A criação da pool foi recusada',
        deleteTitle: 'Eliminar pool',
        deleteBody: 'A pool {pool} e CADA objeto dentro dela são destruídos irreversivelmente. Escreva o nome da pool para confirmar.',
        confirmLabel: 'Nome da pool',
        confirmHint: 'Escreva o nome da pool para confirmar',
        deleteError: 'A eliminação da pool foi recusada',
        detailTitle: 'Detalhes da pool',
        autoscaler: 'PG Autoscaler',
        autoscalerOn: 'Ativado',
        autoscalerOff: 'Desativado',
        autoscalerWarn: 'Notificar',
        pgNumLabel: 'Número de PGs',
        pgNumCaption: 'Observado: o autoscaler pode alterá-lo por conta própria — este campo escreve um desejo.',
        storage: 'Storage TVirt associado',
        addAsStorage: 'Adicionar como storage TVirt',
        ruleSudoHint: 'Alterar a regra CRUSH exige a palavra-passe do operador.',
        updateError: 'A alteração da pool foi recusada',
        updated: 'Alteração da pool iniciada — a observação atualiza-se sozinha'
      },
      crush: {
        section: 'Regras CRUSH',
        notObserved: 'Ainda nenhuma observação CRUSH — o sweep do mon reporta aqui',
        empty: 'Nenhuma regra observada no cluster',
        hint: 'Uma regra decide ONDE acabam as cópias de cada objeto — o seu domínio de falha é a unidade que pode falhar sem perder dados. As pools apontam para uma regra; a replicated_rule builtin (uma réplica por servidor) é o default de nascença.',
        create: 'Criar regra',
        createGuard: 'As regras CRUSH existem só num cluster deployado',
        createTitle: 'Criar regra CRUSH',
        createHint: 'Uma regra = uma escolha de domínio de falha. A regra nasce replicada no root de default — o trabalho é feito por uma task num nó MON; associe as pools a partir do tab Pools depois.',
        createError: 'A criação da regra foi recusada',
        name: 'Nome da regra',
        nameHint: 'DNS-safe (minúsculas, dígitos, hífenes).',
        domain: 'Domínio de falha',
        domainChoice: {
          osd: 'Cada réplica num OSD diferente',
          host: 'Cada réplica num servidor diferente',
          rack: 'Cada réplica num rack diferente'
        },
        domainCustom: 'Personalizada (steps escritos à mão)',
        domainOther: 'Cada réplica num {type} diferente',
        rackGuardHint: 'Nenhum bucket rack existe na hierarquia observada: a regra pode ser criada na mesma, mas nenhuma pool poderá apontar para ela enquanto um rack não for declarado no posicionamento dos servidores membros (definições do nó) — a task de realinhamento constrói o bucket e a associação abre-se sozinha.',
        treeTitle: 'Hierarquia observada',
        treeNotObserved: 'Nenhuma observação da hierarquia — o sweep do mon reporta aqui',
        treeOsds: '{n} OSD',
        treeHint: 'O mapa CRUSH tal como o cluster o vê: root → níveis declarados → servidores (hosts) → OSDs. A topologia segue o posicionamento declarado de cada servidor (definições do nó) — uma mudança de posição realinha-a via task.',
        unplacedWarning: 'Membros sem posição declarada: {nodes} — os seus hosts ficam diretamente sob a root, fora da topologia declarada. Declare a posição nas definições do nó (um aviso, nunca um bloqueio).',
        colName: 'Nome',
        colDomain: 'Domínio de falha',
        colPools: 'Pools',
        builtinChip: 'builtin',
        builtinGuard: 'A regra de default do cluster — a plataforma nunca a elimina',
        detailAction: 'Detalhe da regra',
        detailType: 'Tipo',
        backToRules: 'Regras',
        ruleNotObserved: 'A lista observada de regras não nomeia esta regra',
        noPools: 'Nenhuma pool assenta nesta regra',
        delete: 'Eliminar regra',
        deleteTitle: 'Eliminar regra CRUSH',
        deleteBody: 'A regra {rule} é removida da crushmap do cluster. Nenhuma pool pode assentar nela. Escreva o nome da regra para confirmar.',
        deleteGuard: 'Usada pela pool {name} — aponte primeiro a pool para outra regra',
        confirmLabel: 'Nome da regra',
        confirmHint: 'Escreva o nome da regra para confirmar',
        deleteError: 'A eliminação da regra foi recusada',
        changeRule: 'Mudar regra CRUSH',
        changeRuleTitle: 'Mudar regra CRUSH',
        changeRuleHint: 'A pool começa a colocar os seus objetos segundo a regra escolhida — o Ceph move os dados existentes para se conformar (numa pool cheia segue-se um reequilíbrio).',
        changeRuleError: 'A mudança de regra foi recusada',
        rule: 'Regra CRUSH',
        rawTitle: 'Crushmap em bruto (decompilada)',
        rawWarning: 'PERIGO: este texto é TODA a política de posicionamento do cluster. Um mapa errado pode partir o placement de todas as pools ao mesmo tempo. Guardar compila e testa o mapa com o crushtool ANTES de o injetar — mas um mapa válido pode ainda assim ser uma má ideia.',
        rawReload: 'Recarregar',
        rawLoading: 'Query em curso — uma task read-only está a decompilar a crushmap…',
        rawSave: 'Guardar crushmap',
        rawSaveTitle: 'Injetar crushmap',
        rawSaveBody: 'O texto editado substitui a crushmap do cluster INTEIRO depois de compile + test do crushtool. Escreva o nome do cluster para confirmar.',
        rawConfirmLabel: 'Nome do cluster',
        rawConfirmHint: 'Escreva {name} para confirmar',
        rawError: 'A operação sobre a crushmap falhou',
        rawHint: 'O texto é a forma crushtool -d. Erros de compilação e de teste voltam palavra por palavra do crushtool — o mapa nunca chega ao cluster se qualquer uma das duas barreiras falhar.'
      },
      objects: {
        poolsSection: 'Explorador de objetos',
        poolsHint: 'Escolha uma pool para listar as suas imagens RBD. Cada leitura profunda corre como task read-only num nó MON — nunca bloqueia (nem é bloqueada por) as operações reais.',
        deployedGuard: 'As queries sobre objetos respondem só num cluster deployado',
        browse: 'Explorar os objetos',
        detailAction: 'Detalhe da imagem',
        backToPools: 'Pools',
        backToImages: 'Imagens',
        refresh: 'Atualizar',
        loading: 'Query em curso — uma task read-only está a interrogar o cluster…',
        error: 'A query falhou',
        retry: 'Tentar novamente',
        notRbd: 'Pool com application "{app}" — não contém imagens RBD, nada para explorar aqui',
        noImages: 'Nenhuma imagem RBD nesta pool',
        colImage: 'Imagem',
        colSize: 'Tamanho',
        colObjects: 'Objetos',
        colSnapshots: 'Snapshots',
        imagesHint: 'Os discos num storage rbd consumidor são imagens com o nome do seu id de disco. A contagem de objetos é a provisionada (tamanho / tamanho do objeto) — a utilização real vive no detalhe da imagem.',
        infoTitle: 'Imagem',
        infoSize: 'Tamanho virtual',
        infoObjects: 'Objetos (provisioned)',
        infoObjectSize: 'Tamanho do objeto',
        infoPrefix: 'Prefixo dos objetos',
        infoFormat: 'Formato',
        infoFeatures: 'Features',
        usageTitle: 'Utilização real (rbd du)',
        usageOf: 'de {provisioned} GiB provisionados',
        usageHint: 'Thin por natureza: só os objetos escritos ocupam bytes.',
        watchersTitle: 'Watchers',
        noWatchers: 'Nenhum watcher — nada tem esta imagem aberta neste momento',
        snapshotsTitle: 'Snapshots RBD',
        noSnapshots: 'Nenhum snapshot RBD nesta imagem',
        colSnapshot: 'Snapshot',
        colProtected: 'Protegido',
        colTimestamp: 'Criado',
        protected: 'protegido',
        mappingTitle: 'Mapeamento físico (conjunto OSD)',
        mappingSampled: 'Amostra de {sampled} objetos em {total} — um resumo honesto: para imagens grandes o conjunto converge para TODOS os OSDs da pool (o CRUSH distribui os objetos por toda a pool).',
        mappingComplete: 'Todos os objetos mapeados ({total} de {total}).',
        objectQueryTitle: 'Mapear um único objeto',
        objectName: 'Nome do objeto',
        objectHint: 'Os nomes de objeto RADOS são <prefixo>.<índice 16-hex> — ceph osd map responde com o PG e os conjuntos OSD.',
        mapObject: 'Mapear',
        primary: 'primário: osd.{osd}'
      },
      registerDevice: {
        title: 'Registar dispositivo OSD',
        hint: 'Num cluster vivo o registo também PREPARA o dispositivo: torna-se um OSD BlueStore com uma task automática com afinidade ao nó (nunca vazio, ratificado 2026-07-24). Um dispositivo pertence no máximo a um cluster Ceph em toda a frota.',
        disk: 'Disco de dados',
        diskHint: 'Os discos de dados declarados do nó — nome e número de série',
        noDeclared: 'Nenhum disco de dados declarado neste nó — marque-os primeiro nas definições locais do nó',
        serialHint: 'O número de série do dispositivo — o pin de identidade',
        encrypted: 'Encriptar este OSD (dmcrypt)',
        encryptedHint: 'A escolha por OSD (o modo do cluster é "escolhida por cada OSD"): congela-se neste disco no momento do registo — uma mudança de modo posterior nunca a reescreve; fá-lo a ação de linha encriptar/desencriptar.',
        error: 'O registo foi recusado'
      },
      unregisterDevice: {
        title: 'Anular registo do dispositivo',
        body: 'Só registo: {name} deixa de ser um candidato a OSD deste cluster. Os seus bytes não são tocados.',
        error: 'A anulação do registo foi recusada'
      },
      deploy: {
        action: 'Repetir deploy',
        title: 'Repetir o bootstrap',
        body: 'O bootstrap de nascença recomeça a partir da configuração atual: os mons arrancam, cada dispositivo registado é preparado e ativado como OSD BlueStore. A operação corre como macrotask — a fase atualiza-se sozinha.',
        started: 'Bootstrap iniciado — prossegue como macrotask; a fase atualiza-se sozinha',
        error: 'O bootstrap foi recusado'
      },
      propose: {
        action: 'Propor como storage',
        title: 'Propor como storage',
        hintPool: 'A pool existente {name} torna-se um storage TVirt: uma identidade cephx limitada à pool acaba no keystore e o storage ceph-rbd nasce pronto. A proposta consome a pool — nunca cria nenhuma.',
        hintFs: 'O filesystem existente {name} torna-se um storage TVirt: uma identidade cephx limitada ao filesystem acaba no keystore e o storage cephfs nasce pronto e montado. A proposta consome o filesystem — nunca cria nenhum.',
        name: 'Nome do storage',
        nameHint: 'DNS-1123, único no scope — a identidade cephx recebe o nome dele.',
        path: 'Path dentro do filesystem',
        pathHint: 'Path absoluto dentro do filesystem que o storage monta — / em caso de dúvida.',
        alsoPropose: 'Propor já como storage',
        alsoProposePoolHint: 'Depois da criação o mesmo gesto propõe a pool recém-nascida como storage ceph-rbd — duas chamadas explícitas, um único dialog.',
        alsoProposeFsHint: 'Depois da criação o mesmo gesto propõe o filesystem recém-nascido como storage cephfs — duas chamadas explícitas, um único dialog.',
        guard: 'Propor como storage — só num cluster healthy',
        started: 'Proposta aceite — o storage está a materializar-se; encontra-o em Storage',
        submit: 'Criar storage',
        error: 'A proposta foi recusada'
      },
      fs: {
        section: 'Filesystems',
        create: 'Criar filesystem',
        createGuard: 'Os filesystems existem só num cluster deployado',
        mdsFirstGuard: 'Adicione primeiro um MDS — um filesystem sem metadata server nasce inutilizável',
        notObserved: 'Nenhuma observação dos filesystems — o sweep do MON reporta aqui',
        empty: 'Nenhum filesystem no cluster',
        colName: 'Nome',
        colPools: 'Pools',
        colMds: 'MDS',
        noActiveMds: 'nenhum MDS ativo',
        delete: 'Remover filesystem',
        deleteGuard: 'Consumido pelo storage {name} — elimine primeiro o storage',
        hint: 'Um filesystem é dono das suas pools de dados e metadata (cephfs.<nome>.data / .meta): nascem com ele e morrem com ele — removeFs, nunca um delete de pool à mão. Esta tabela é a verdade observada pelo sweep do MON.',
        createTitle: 'Criar filesystem',
        createHint: 'O filesystem nasce no cluster com as suas duas pools (application cephfs) e é servido pelos MDS declarados — o trabalho é feito por uma task num nó MON. Ligue "Propor como storage" para o consumir logo no mesmo gesto.',
        name: 'Nome do filesystem',
        nameHint: 'DNS-safe (minúsculas, dígitos, hífenes).',
        sizeHint: 'Réplicas de AMBAS as pools nascentes. Default 3.',
        createError: 'A criação do filesystem foi recusada',
        deleteTitle: 'Remover filesystem',
        deleteBody: 'O filesystem {fs} e CADA ficheiro dentro dele são destruídos irreversivelmente — as suas pools de dados e metadata morrem com ele. Escreva o nome do filesystem para confirmar.',
        confirmLabel: 'Nome do filesystem',
        confirmHint: 'Escreva o nome do filesystem para confirmar',
        deleteError: 'A remoção do filesystem foi recusada'
      },
      destroy: {
        action: 'Destruir',
        retryAction: 'Repetir a eliminação',
        retryGuard: 'A destruição está a correr — o retry vale para uma destruição falhada (o lease recusa caso contrário)',
        title: 'Destruir o cluster',
        body: 'O fabric deployado é desmantelado: cada daemon deste cluster para, o seu estado de sistema e as chaves no keystore são libertados. Com a destruição concluída o cluster é removido automaticamente.',
        confirmLabel: 'Nome do cluster',
        confirmHint: 'Escreva o nome do cluster para confirmar',
        wipe: 'Limpar os dispositivos registados',
        wipeHint: 'Marcada: as assinaturas de cada dispositivo registado são apagadas — os dados neles são destruídos. Desmarcada: os bytes ficam intactos e os dispositivos voltam a registados.',
        guard: 'Destruir — nada deployado',
        started: 'Destruição iniciada — prossegue como macrotask; a fase atualiza-se sozinha',
        error: 'A destruição foi recusada'
      },
      delete: {
        guard: 'Eliminar — só uma configuração não deployada (destrua primeiro)',
        title: 'Eliminar {name}?',
        body: 'A configuração e o seu registo de dispositivos são removidos. Legal só enquanto nada estiver deployado.',
        error: 'A eliminação foi recusada'
      }
    }
  }
}
